import { RepairTypeResource as Res } from '@shared/resources/repair-type';
import { RepairTypeCreateUpdateDto as DTO } from '@shared/dto/repair-type';
import { RepairTypesService } from '@/services/repair-types.service';
import { defineCrudStore } from '@/stores/crud-store';

export const useRepairTypesStore = defineCrudStore<DTO, DTO, Res>({
  storeId: 'repairTypes',
  service: new RepairTypesService(),
});
